module.exports = __webpack_public_path__ + "img/SPC_Sword5 Clean OneMaterial.4c79e5b0.png";